export default "__VITE_ASSET__CtsY0Mcx__"